import { render, staticRenderFns } from "./MatchHeaderSkeletonLoader.vue?vue&type=template&id=198ef8f9&scoped=true&"
import script from "./MatchHeaderSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./MatchHeaderSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./MatchHeaderSkeletonLoader.vue?vue&type=style&index=0&id=198ef8f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198ef8f9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VContainer,VRow,VSkeletonLoader})
